import { Content } from "../types";

/**
 * Filtro del buscador: se queda con los contenidos cuyo nombre o primera
 * descripción contienen el texto buscado, sin distinguir mayúsculas. Todo
 * ocurre en el cliente, sobre lo que ya descargó `v7/getPromos`.
 *
 * Un contenido sin descripción se busca solo por nombre: sin Error Boundary en
 * el proyecto, leer `details[0]` sin guarda desmontaría la aplicación entera.
 */
export const searchContents = (
  contents: Content[],
  searchingContent: string
): Content[] => {
  const text = searchingContent.toLowerCase();

  return contents.filter(
    ({ name, details }) =>
      name.toLowerCase().includes(text) ||
      (details[0]?.description ?? "").toLowerCase().includes(text)
  );
};
